'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _templateObject = _taggedTemplateLiteral(['\n        .letter, .copyright {\n            fill: ', ';\n        }\n        .roof {\n            fill: ', ';\n        }\n    '], ['\n        .letter, .copyright {\n            fill: ', ';\n        }\n        .roof {\n            fill: ', ';\n        }\n    ']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _colors = require('../../styles/colors');

var _colors2 = _interopRequireDefault(_colors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ClaytonLogo = function ClaytonLogo(_ref) {
    var height = _ref.height,
        width = _ref.width,
        letterColor = _ref.letterColor,
        rooftopColor = _ref.rooftopColor;


    var Logo = _styledComponents2.default.svg(_templateObject, letterColor ? letterColor : _colors2.default.primaryClaytonBlue, rooftopColor ? rooftopColor : _colors2.default.primaryClaytonGreen);

    return _react2.default.createElement(
        Logo,
        { width: width ? width : '100', height: height ? height : '35', className: 'clayton-logo', version: '1.1', x: '0px', y: '0px',
            viewBox: '0 0 414 184', style: { enableBackground: 'new 0 0 414 184' } },
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { className: 'reg copyright', d: 'M372.3,139.5c-2.8,0-4.7-2.1-4.7-4.8c0-2.9,2.2-4.8,4.7-4.8c2.5,0,4.7,1.9,4.7,4.8\r C377,137.6,374.8,139.5,372.3,139.5 M372.3,130.7c-2.1,0-3.7,1.6-3.7,4c0,2.2,1.4,4,3.7,4c2.1,0,3.7-1.6,3.7-4\r C375.9,132.3,374.3,130.7,372.3,130.7 M371.3,137.4h-0.9v-5.3h2c1.3,0,1.9,0.4,1.9,1.5c0,1-0.6,1.4-1.4,1.5l1.5,2.3h-1l-1.4-2.3\r h-0.8V137.4L371.3,137.4z M372.3,134.4c0.7,0,1.2-0.1,1.2-0.8c0-0.6-0.6-0.7-1.2-0.7h-1.1v1.6H372.3L372.3,134.4z' }),
            _react2.default.createElement('path', { className: 'C letter', d: 'M94.6,90.6c-0.5-18-18-28.3-34.2-28.3c-22.6,0-37.3,17.3-37.3,39c0,21.7,14.7,39,37.3,39\r c19,0,33.1-11.3,34.2-30.6H75.1c-0.7,8.6-6,13.9-15.1,13.9c-12.6,0-17.4-11.1-17.4-22.2c0-11.1,4.8-22.2,17.4-22.2\r c8.2,0,14.1,4,15.1,11.5H94.6L94.6,90.6L94.6,90.6z' }),
            _react2.default.createElement('polygon', { className: 'l letter', points: '97,63.9 114.9,63.9 114.9,138.8 97,138.8 97,63.9 97,63.9 \t' }),
            _react2.default.createElement('path', { className: 'a letter', d: 'M135.6,101.1c0.8-4.6,4-6.8,8.9-6.8c3.7,0,8.6,1.6,8.6,5.7c0,3.4-1.7,4.4-4.7,5\r c-12.4,2.5-31.7,1.1-31.7,18.9c0,11.2,8.2,16.5,18.6,16.5c6.5,0,13.3-1.9,17.9-6.7c0.2,1.8,0.4,3.5,1.1,5.1h17.9\r c-2.1-4.3-2.1-9.3-2.1-14V101c0-15.4-12.5-18.3-25.4-18.3c-6.2,0-12.5,1.1-17.3,3.8c-4.8,2.8-8.2,7.4-8.5,14.6H135.6L135.6,101.1\r L135.6,101.1z M134.5,123.2c0-4.3,3.3-6,7.3-6.9c3.9-1.1,8.5-1.4,11-2.9c0.4,11.2-2.4,16-10.9,16\r C138,129.4,134.5,127.6,134.5,123.2L134.5,123.2L134.5,123.2z' }),
            _react2.default.createElement('path', { className: 'y letter', d: 'M225.2,84.3h-18.2l-10.3,35.5h-0.2l-10.3-35.5h-18.9l14.1,37.9c1,2.9,4.5,11.3,4.5,14.2\r c0,3.8-3,6.1-7.1,6.1h-6.2v14.5h8.4c12.1,0,18.5-1.5,22.8-13.4L225.2,84.3L225.2,84.3L225.2,84.3z' }),
            _react2.default.createElement('path', { className: 't letter', d: 'M255.3,84.3h-11V67.9h-17.8v16.5h-9v11.6h9v24.2c0,14.8,3.9,19.2,19.1,19.2c3.3,0,6.5-0.4,9.8-0.5v-13.1\r c-1.6,0-3.2,0.2-4.6,0.2c-3.9,0-6.4-0.9-6.4-5.2V95.9h11V84.3L255.3,84.3L255.3,84.3z' }),
            _react2.default.createElement('path', { className: 'o letter', d: 'M252.9,111.6c0,16.4,11.8,28.7,28.6,28.7c16.9,0,28.7-12.4,28.7-28.7c0-16.4-11.9-28.9-28.7-28.9\r C264.6,82.8,252.9,95.3,252.9,111.6L252.9,111.6L252.9,111.6z M270.7,111.6c0-6.9,2.5-15.2,10.8-15.2c8.3,0,10.9,8.3,10.9,15.2\r c0,6.9-2.6,15.1-10.9,15.1C273.2,126.7,270.7,118.6,270.7,111.6L270.7,111.6L270.7,111.6z' }),
            _react2.default.createElement('path', { className: 'n letter', d: 'M311.7,138.8h17.8v-29.7c0-6,2.9-11.6,9.7-11.6c9.8,0,8.9,7.5,8.9,15v26.3H366v-34.9\r c0-7.8-1.5-21.1-19.6-21.1c-6.5,0-13.8,3.5-17.1,9h-0.2v-7.5h-17.3V138.8L311.7,138.8L311.7,138.8z' }),
            _react2.default.createElement('polygon', { className: 'roof',
                points: '141.2,63.2 235.1,26.8 329.1,63.2 329.1,70 235.1,50 141.2,70 141.2,63.2 141.2,63.2 \t' })
        )
    );
};

exports.default = ClaytonLogo;


//////////////////
// WEBPACK FOOTER
// ./~/pubweb-react-components/dist/images/svg/ClaytonLogo.js
// module id = 479
// module chunks = 168707334958949